import React from 'react';
import { KTSVG, LoadingGrid, TableList } from '../../../../rbts/helpers';
import { useGetAllShiftSupplier } from '../hooks/StartShiftHook';

type Props = {
  reloadGrid: number;
  editRegister: (id: number) => void;
  removeRegister: (id: number) => void;
  toggleRegister: (id_punto_venta: number, is_app_visible: boolean) => void;
};

const ShiftSupplierGrid: React.FC<Props> = ({ reloadGrid, editRegister, removeRegister, toggleRegister }) => {
  const { loadingRequest, shiftList } = useGetAllShiftSupplier(reloadGrid);

  const columns: any = [
    {
      id: 'punto_venta',
      name: <div className="fw-bolder text-muted me-5">Punto de venta</div>,
      selector: (row: any) => row.nombre_punto_venta,
      cell: (row: any) => (
        <>
          <span>{row.nombre_punto_venta}</span>
        </>
      ),
      sortable: true,
      width: '22%',
    },
    {
      id: 'turno',
      name: <div className="fw-bolder text-muted me-5">Turno</div>,
      selector: (row: any) => row.estatus_punto_venta,
      cell: (row: any) => (
        <>
          <span
            className={` badge ${
              row.estatus_punto_venta == 'Abierto'
                ? 'badge-success'
                : 'badge-danger'
            }`}
          >
            {row.estatus_punto_venta}
          </span>
        </>
      ),
      sortable: true,
      width: '10%',
    },
    {
      id: 'abierto',
      name: <div className="fw-bolder text-muted me-5">Abierto por:</div>,
      cell: (row: any) => (
        <>
          <span className="">{row.abierto_por ? row.abierto_por : 'N/A'}</span>
        </>
      ),
      sortable: false,
      width: '23%',
    },
    {
      id: 'cerrado',
      name: <div className="fw-bolder text-muted me-5">Cerrado por:</div>,
      cell: (row: any) => (
        <>
          <span className="">{row.cerrado_por ? row.cerrado_por : ''}</span>
        </>
      ),
      sortable: false,
      width: '23%',
    },
    {
      id: 'conciliado',
      name: <div className="fw-bolder text-muted me-5">Conciliado</div>,
      selector: (row: any) => row.isConciliado,
      cell: (row: any) => (
        <>
          <span
            className={` badge ${
              row.isConciliado ? 'badge-success' : 'badge-danger'
            }`}
          >
            {row.isConciliado ? 'conciliado' : 'No conciliado'}
          </span>
        </>
      ),
      sortable: true,
      width: '14%',
    },
    {
      id: 'acciones',
      name: <div className="fw-bolder text-muted me-5"></div>,
      cell: (row: any) => (
        <div className="d-flex">
          {row.is_active !== false && (
            <button
              className="btn btn-icon btn-active-color-primary btn-sm me-1"
              title="Editar punto de venta"
              onClick={() => editRegister(row.id_punto_venta)}
            >
              <KTSVG
                path="/media/icons/duotune/art/art005.svg"
                className="svg-icon-3"
              />
            </button>
          )}
          <button
            className={`btn btn-icon btn-sm me-1 ${row.is_active !== false ? 'text-success' : 'text-danger'}`}
            title={row.is_active !== false ? 'Desactivar punto de venta' : 'Activar punto de venta'}
            onClick={() => toggleRegister(row.id_punto_venta, row.is_active !== false)}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path d="M7.5 1v7h1V1h-1z"/>
              <path d="M3 8.812a4.999 4.999 0 0 1 2.578-4.375l-.485-.874A6 6 0 1 0 11 3.616l-.501.865A5 5 0 1 1 3 8.812z"/>
            </svg>
          </button>
          <button
            className="btn btn-icon btn-active-color-danger btn-sm"
            title="Eliminar punto de venta del día"
            onClick={() => removeRegister(row.id)}
          >
            <KTSVG
              path="/media/icons/duotune/general/gen027.svg"
              className="svg-icon-3"
            />
          </button>
        </div>
      ),
      sortable: false,
      width: '16%',
    },
  ];
  return loadingRequest ? (
    <LoadingGrid text="Cargando..."></LoadingGrid>
  ) : (
    <TableList data={shiftList} columns={columns} fillHeight></TableList>
  );
};

export { ShiftSupplierGrid };
